/**
 * De una lectura a lo que usan los formularios (F13.3)
 *
 * El resolvedor identifica; los formularios trabajan con las opciones de
 * siempre (artículo CONFIGURADO en el almacén, con sus unidades y saldo;
 * lote con su saldo allí). Se piden a los mismos selectores, así que el
 * ámbito y las reglas son exactamente los de la elección manual.
 */
import { api, type OpcionArticuloStock, type OpcionLote } from '../api.ts';

export async function opcionArticulo(id: string, codigo: string, idAlmacen: string | null): Promise<OpcionArticuloStock | null> {
  const p = new URLSearchParams({ texto: codigo, limite: '50' });
  if (idAlmacen !== null) p.set('idAlmacen', idAlmacen);
  const r = await api.get<{ filas: OpcionArticuloStock[] }>(`/api/inventario/opciones/articulos?${p.toString()}`);
  return r.filas.find((a) => a.id === id) ?? null;
}

export async function opcionLote(idArticulo: string, idLote: string, codigo: string, idAlmacen: string | null): Promise<OpcionLote | null> {
  const p = new URLSearchParams({ idArticulo, texto: codigo, activo: 'TODOS', limite: '20' });
  if (idAlmacen !== null) p.set('idAlmacen', idAlmacen);
  const r = await api.get<{ filas: OpcionLote[] }>(`/api/inventario/opciones/lotes?${p.toString()}`);
  return r.filas.find((l) => l.id === idLote) ?? null;
}

/** Suma de cantidades en texto (admite coma decimal) sin perder precisión visible. */
export function sumar(actual: string, mas: number): string {
  const a = Number((actual.trim() === '' ? '0' : actual).replace(',', '.'));
  if (!Number.isFinite(a)) return String(mas);
  return String(Number((a + mas).toFixed(6)));
}

/** Añade una serie a una lista «una por línea»; null si ya estaba (serie repetida). */
export function anadirSerie(lista: string, numero: string): string | null {
  const ya = lista.split(/[\s,;]+/).map((s) => s.trim().toUpperCase()).filter((s) => s !== '');
  if (ya.includes(numero.trim().toUpperCase())) return null;
  return lista.trim() === '' ? numero : `${lista.replace(/\s+$/, '')}\n${numero}`;
}
